import { Action } from 'redux';

import { DeleteGroups, EditGroup, GroupAddUsers, GroupRemoveUsers, SyncAdGroup, SyncAdGroups, UpdateGroupsMinimumSiteRole, UpdateLocalGroupsLicenseUponLogin } from '../../../bootstrap/redux/actions/AppActionTypes';
import { ISiteUserInfo } from '../../users/models/ISiteUserInfo';
import { IGroupInfo } from '../models/IGroupInfo';

export interface GroupUserAddAction extends Action {
  group: IGroupInfo;
}

export function addSiteUsersToGroup(group: IGroupInfo): GroupUserAddAction {
  return {
    type: GroupAddUsers,
    group
  };
}

export interface GroupMenuAction extends Action {
  items: ISiteUserInfo[];
}

export function removeSiteUsersFromGroup(items: ISiteUserInfo[]): GroupMenuAction {
  return {
    type: GroupRemoveUsers,
    items,
  };
}

export interface GroupSyncAction extends Action {
  groups: IGroupInfo[];
}

export function syncAdGroup(groups: IGroupInfo[]): GroupSyncAction {
  return {
    type: SyncAdGroup,
    groups
  };
}

export function syncAdGroups(groups: IGroupInfo[]): GroupSyncAction {
  return {
    type: SyncAdGroups,
    groups
  };
}

export interface GroupMinimumSiteRoleUpdateAction extends Action {
  groups: IGroupInfo[];
}

export function updateGroupMinSiteRole(groups: IGroupInfo[]): GroupMinimumSiteRoleUpdateAction {
  return {
    type: UpdateGroupsMinimumSiteRole,
    groups
  };
}

export interface LocalGroupLicenseUponLoginUpdateAction extends Action {
  groups: IGroupInfo[];
}

export function updateLocalGroupsLicenseUponLogin(groups: IGroupInfo[]): LocalGroupLicenseUponLoginUpdateAction {
  return {
    type: UpdateLocalGroupsLicenseUponLogin,
    groups
  };
}

export interface GroupsDeleteAction extends Action {
  groups: IGroupInfo[];
}

export function deleteGroups(groups: IGroupInfo[]): GroupsDeleteAction {
  return {
    type: DeleteGroups,
    groups
  };
}

export interface GroupEditAction extends Action {
  group: IGroupInfo;
}

export function editGroup(group: IGroupInfo): GroupEditAction {
  return {
    type: EditGroup,
    group
  };
}
